import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IceButton from "../../components/Button";
import {Alert, AlertTitle} from "@mui/material";


export default function DialAddNewProj(props: any) {

    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)
    let {open, setOpen, projObj, setProjObj} = props

    async function handleSave() {
        try {
            const res = await fetch(`${serverIP}/addnewproj/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + String(authTokens.access)
                },
                body: JSON.stringify(projObj),
            })

            const data = await res.json()
            setSaveCode(data.code)
        } catch (error) {
            console.log("Failed to add project:", error)
        }
        // setOpen(false)    // a dialog must be closed anyway after Save is clicked
    }

    function handleChange(value: string, name: string) {
        setProjObj((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value.trimStart()}
        })
    }

    const [saveCode, setSaveCode] = useState<number>(0)
    // console.log(saveCode)

    useEffect(() => {
        if (saveCode > 0) {
            const timeId = setTimeout(() => {

                cleanProjObj()
                setSaveCode(0)

                if (saveCode === 200) {
                    setOpen(false)
                }
            }, 3000)

            return () => {
                clearTimeout(timeId)
            }
        }
    }, [saveCode])



    useEffect(() => {
        setIsFormValid((prev: any) => {
                return !Object.values(projObj).some((val) => val === '' || val == null)
            })

    }, [projObj])

    const [isFormValid, setIsFormValid] = useState<boolean>(false)

    const formFields = {
        'srcTaxID': 'Source Tax ID',
        'srcTaxName': 'Source Tax Name',
        'trgTaxID': 'Target Tax ID',
        'trgTaxName': 'Target Tax Name'
    }

    const formElements: any = Object.keys(formFields).map((obj_key: any, index) => {
        let objVal: any = formFields[obj_key as keyof typeof formFields]

        return <React.Fragment key={obj_key}>
            <span className="field-label">{objVal}</span>
            <input
                name={obj_key}
                type="text"
                className={projObj[obj_key] ? "filter-input": "filter-input-error"}
                onChange={(event) => handleChange(event.target.value, event.target.name)}
                value={projObj[obj_key]}
            />
        </React.Fragment>
    })

    function cleanProjObj() {
        let newObj: any = {}
        for (let k in projObj) {
            newObj[k] = ''
            }
        setProjObj(newObj)
    }


    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            {saveCode === 200 && <Alert severity="success">The project has been created!</Alert>}
            {saveCode === 304 && <Alert severity="warning">The project with given parameters already exists!</Alert>}

            <DialogTitle>Adding new project</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    Please insert key parameters of a new project (all fields are mandatory):
                </DialogContentText>


                <div className="dial-add-newproj">
                    {formElements}
                </div>

            </DialogContent>

            <DialogActions sx={{marginBottom: "10px", marginRight: "15px !important", marginTop: "10px !important"}}>
                <IceButton type={!isFormValid || saveCode === 200 ? "secondary": "primary"} text="Save" onclick={isFormValid ? handleSave: ()=>{} } disabled={!isFormValid || saveCode === 200}/>
                <IceButton
                    type="delete"
                    text="Cancel"
                    onclick={() => {
                        setOpen(false)
                        cleanProjObj()
                    }
                } />
            </DialogActions>

        </Dialog>
    );
}
